import { createContext, useContext, useMemo, useState } from "react";
import { Temporal } from "temporal-polyfill";

interface AnalyticsMonthContext {
  selectedMonthRange: [Temporal.PlainDate, Temporal.PlainDate];
  setSelectedMonthRange: (range: [Temporal.PlainDate, Temporal.PlainDate]) => void;
  formatedMonthRange: string;
}
const NOW = Temporal.Now.plainDateISO();
const AnalyticsMonthContext = createContext<AnalyticsMonthContext | undefined>(undefined);

export function AnalyticsMonthProvider({ children }: { children: React.ReactNode }) {
  const [selectedMonthRange, setSelectedMonthRange] = useState<[Temporal.PlainDate, Temporal.PlainDate]>([
    NOW.subtract({ months: 5 }),
    NOW.subtract({ months: 1 }),
  ]);

  const formatedMonthRange = useMemo(() => {
    if (!selectedMonthRange) return "";

    const [start, end] = selectedMonthRange;
    const startMonth = start.toLocaleString("en-US", { month: "short" });
    const endMonth = end.toLocaleString("en-US", { month: "short" });

    return `${startMonth}, ${start.year} - ${endMonth}, ${end.year}`;
  }, [selectedMonthRange]);

  return (
    <AnalyticsMonthContext.Provider value={{ selectedMonthRange, setSelectedMonthRange, formatedMonthRange }}>
      {children}
    </AnalyticsMonthContext.Provider>
  );
}

export function useAnalyticsMonth() {
  const context = useContext(AnalyticsMonthContext);

  if (!context) {
    throw new Error("useMonthRange must be used within a MonthRangeProvider");
  }

  return context;
}
